import React, { useEffect, useState } from "react";
import { Card, Input, Select, Button, Row, Col, Tabs, Table, message, Form, Tag, Modal, } from "antd";
import { EditFilled, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ClosedUserEnquiries, getAllInternalUsers, getServiceCentersList, getServiceenquiries, getUserServiceenquiries, SetEnquiry, UserEnquiries } from "../services/apiService";
import { stateList } from "../services/Cart";

const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;
const { Search } = Input;

const ServiceHistory = () => {
  const [form] = Form.useForm();
  const [enquiries, setEnquiries] = useState([])
  const [loading, setLoading] = useState(false)
  const [services, setServices] = useState([]);
  const [states, setStates] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [closeddata, setClosedData] = useState([])
  const [data, setData] = useState([])
  const [users, setUsers] = useState([]);
  const [formloading, setformloading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const serviceType = Form.useWatch("servicetype", form);
  const [usertype, setUsertype] = useState('')
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState(enquiries);
  const today = new Date().toISOString().split("T")[0];
  const [processdates, setProcessDates] = useState({
    fromDate: today,
    toDate: today,
  });
  const [dates, setDates] = useState({
    fromDate: today,
    toDate: today,
  });
  const navigate = useNavigate()
  const isPurchase = serviceType === "Purchase";
  useEffect(() => {
    form.setFieldsValue({
      serviceperson: undefined, // reset field
    });
  }, [serviceType]);

  useEffect(() => {
    const userid = localStorage.getItem('userType')
    setUsertype(userid)
    loaduserEnquries()
    fetchStates()
    fetchServiceCenters();
    fetchUsers();
    fetchClosedEnquiries();
  }, [formloading, dates, processdates]);
  const fetchUsers = async () => {
    try {
      const data = await getAllInternalUsers();
      setUsers(data.Data || []);
    } catch (error) {
      console.error("Failed to fetch users:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchClosedEnquiries = async () => {
    try {
      setLoading(true);
      const res = await ClosedUserEnquiries(localStorage.getItem('userId'), dates.fromDate, dates.toDate);
      setClosedData(res.data || []);
      console.log("sercen", res.data);
    } catch (error) {
      console.error("Warranty list error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Filter every time searchValue changes
    if (!searchValue) {
      setFilteredData(enquiries); // no filter, show all
    } else {
      const filtered = enquiries.filter((item) =>
        item.mobilenumber.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchValue, enquiries]);


  const fetchServiceCenters = async () => {
    try {
      setLoading(true);
      const res = await getServiceCentersList();
      setData(res.data || []);
      console.log("sercen", res.data);
    } catch (error) {
      console.error("Warranty list error:", error);
    } finally {
      setLoading(false);
    }
  };

  // const loadEnquiries = async () => {
  //   try {
  //     setLoading(true);
  //     const res = await getUserServiceenquiries();
  //     console.log(res)
  //     setEnquiries(res.data || []);
  //   } catch (e) {
  //     console.error("Error loading product spares:", e);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const loaduserEnquries = async (id) => {
    try {
      const payload = {
        id: localStorage.getItem('userId')
      };

      const response = await getUserServiceenquiries(localStorage.getItem('userId'),
       processdates.fromDate, processdates.toDate);
      console.log("usersenqui", response)
      if (response) {
        setEnquiries(response.data || []);
        // message.success("Service request submitted successfully");
      } else {
        // message.error("Failed to submit request");
      }
    } catch (err) {
      console.error("API Error:", err);
      // better error handling
      message.error(
        err?.response?.data?.message || "Something went wrong. Please try again"
      );
    }
  };


  const onFinish = async (values) => {
    setformloading(true)
    try {
      const payload = {
        ...values,
        date: new Date().toISOString(),
        status: 'Created'
      };

      console.log("Submitting:", payload); // debug

      const response = await SetEnquiry(payload);


      message.success("Service request submitted successfully");
      form.resetFields();

      setformloading(false)
    } catch (err) {
      console.error("API Error:", err);
      setformloading(false)
      // better error handling
      message.error(
        err?.response?.data?.message || "Something went wrong. Please try again"
      );
    }
  };

  const fetchStates = async () => {
    setLoadingStates(true);
    try {
      const response = await stateList();
      console.log("Full API response:", response.data.List);
      setStates(response.data?.List)
      if (response.data?.List?.length === 0) {
        console.warn("No states found in the response");
        showSnackbar("No states available", "info");
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      showSnackbar("Failed to load states", "error");
    } finally {
      setLoadingStates(false);
    }
  };
  const handleEdit = (record) => {
    setEditingRecord(record);
    setIsModalOpen(true);
    getUserEnquiry(record.id)

    form.setFieldsValue({
      customername: record.customername,
      mobilenumber: record.mobilenumber,
      city: record.city,
      state: record.state,
      servicetype: record.servicetype,
      serviceperson: record.serviceperson,
      priority: record.priority,
      discription: record.discription,
      date: new Date().toISOString(),
      status: record.status,
      shifted: record.id
    });
  };

  const columns = [
    { title: "ID", dataIndex: "id" },
    { title: "Ticket ID", dataIndex: "ticketid" },
    { title: "Customer Name", dataIndex: "customername" },
    { title: "Mobile", dataIndex: "mobilenumber" },
    { title: "City", dataIndex: "city" },
    { title: "State", dataIndex: "state" },
    { title: "Service Type", dataIndex: "servicetype" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => {
            navigate('/EditStatus', { state: { record } })
          }}
        >
          Status
        </Button>),
    }
  ];
  const enquiryColumns = [
    {
      title: "Customer Name",
      dataIndex: "customername",
      key: "customername",
    },
    {
      title: "Mobile No",
      dataIndex: "mobilenumber",
      key: "mobilenumber",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
    },
    {
      title: "Service Type",
      dataIndex: "servicetype",
      key: "servicetype",
    },
    // {
    //   title: "Service Person",
    //   dataIndex: "serviceperson",
    //   key: "serviceperson",
    // },
    // {
    //   title: "Priority",
    //   dataIndex: "priority",
    //   key: "priority",
    //   render: (priority) => {
    //     let color = "blue";
    //     if (priority === "High") color = "red";
    //     else if (priority === "Medium") color = "orange";
    //     else if (priority === "Low") color = "green";

    //     return <Tag color={color}>{priority}</Tag>;
    //   },
    // },
    {
      title: "TicketId",
      dataIndex: "ticketid",
      key: "discription",
      // ellipsis: true,
    },
    // {
    //   title: "Date",
    //   dataIndex: "date",
    //   key: "date",
    //   render: (date) => {
    //     if (!date) return "-";
    //     const d = new Date(date);
    //     return `${String(d.getDate()).padStart(2, "0")}/${String(
    //       d.getMonth() + 1
    //     ).padStart(2, "0")}/${d.getFullYear()}`;
    //   },
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    // },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => {
            navigate('/EditStatus', { state: { record } })
          }}
        >
          Status
        </Button>),
    }
  ];
  // const handleSave = (values) => {
  //   const updatedData = data.map((item) =>
  //     item.key === editingRecord.key ? { ...item, ...values } : item
  //   );

  //   setData(updatedData);
  //   setIsModalOpen(false);
  // };

  const filterData = (status) =>
    services.filter((item) => item.status === status);

  return (<div style={{ padding: 40, backgroundColor: '#ffffff' }}>
    <Tabs defaultActiveKey="2">

      {/* NEW TAB */}
      <TabPane tab="In-Process" key="2">
        <Input
          placeholder="Enter Mobile Number"
          size="large"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          style={{ marginBottom: 20, maxWidth: 400 }}
        />

        {/* Table */}
        <Table
          columns={enquiryColumns}
          dataSource={filteredData}
          rowKey={(record) => record.id || record.mobilenumber}
          pagination={{ pageSize: 10 }}
          scroll={{ x: 'max-content' }}

        />
      </TabPane>

      {/* RESOLVED TAB */}
      <TabPane tab="Closed" key="3">
        <Table rowKey="id" columns={columns} dataSource={closeddata} />
      </TabPane>

    </Tabs>
  </div>
  );
};

export default ServiceHistory;
